import { QuestionsResponse } from '../models/questions-response';
import globalAxios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { mergeHeaders, AxiosHeaders } from '../utilities/merge-headers';

export class QuestionsApi {
    private baseUrl: string;

    public constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async get(headers?: AxiosHeaders): Promise<AxiosResponse<QuestionsResponse>> {
        const request = {
            url: this.baseUrl + '/questions',
            method: 'GET',
            responseType: 'json',
        } as AxiosRequestConfig;

        request.headers = mergeHeaders(request.headers, headers);


        const response = await globalAxios.request<QuestionsResponse>(request);
        

        return response;
    }
}